/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Fac_Btn3Inputs */

const en_dr_room_fac_btn3 = /** @type {(inputs: Dr_Room_Fac_Btn3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persona critique`)
};

const id_dr_room_fac_btn3 = /** @type {(inputs: Dr_Room_Fac_Btn3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritik persona`)
};

/**
* | output |
* | --- |
* | "Persona critique" |
*
* @param {Dr_Room_Fac_Btn3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_fac_btn3 = /** @type {((inputs?: Dr_Room_Fac_Btn3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Fac_Btn3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_fac_btn3(inputs)
	return en_dr_room_fac_btn3(inputs)
});